// extracted by mini-css-extract-plugin
module.exports = {"sortable":"SortableHeader_sortable__2l1bl","sortIcon":"SortableHeader_sortIcon__17wHG","active":"SortableHeader_active__2d1Ki"};